import CookieConsentTitle from "./CookieConsentTitle";

export default CookieConsentTitle;
